var moment = require('moment');
var module = angular.module('octopusApp.infrastructure');

module.filter('moment', function () {
  return function (input, format) {
    var when = new Date(Date.parse(input));
    var m = moment(when);
    format = format || "LLLL";
    var display = format === "ago" ? m.fromNow() : m.format(format);
    return display;
  };
}).filter('momentAgo', function () {
  var fn = function (input) {
    var when = new Date(Date.parse(input));
    return  moment(when).fromNow();
  };
  fn.$stateful = true;
  return fn;
}).filter('momentFrom', function () {
  return function(fromDate, toDate) {
    if (!fromDate) {
      return null;
    }

    var fromMoment = moment(fromDate);
    var toMoment = toDate ? moment(toDate) : moment();

    var diff = fromMoment.diff(toMoment);
    var duration = moment.duration(diff);
    var mins = duration.minutes();
    var hours = duration.hours();
    var days = Math.floor(duration.asDays());
    var result = (mins === 1 ? "1 minute" : mins + " minutes");
    result = (hours !== 0 ? (hours === 1 ? "1 hour" : hours + " hours") + " and " : "") + result;
    result = (days !== 0 ? (days === 1 ? "1 day" : days + " days") + ", " : "") + result;
    return result;
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/moment.js
// module id = 689
// module chunks = 1